import React, { useState } from 'react';
import Button from 'components/Button';
import Form, { FormSubmitHandler } from 'components/Form/Form';
import FormInput from 'components/Form/FormInput';
import Typography from 'components/Typography';

import { FormValidator } from 'components/Form/FormValidator';

import styles from './PasswordResetForm.module.scss';

type FormFields = {
  email: string;
};

const defaultValues: FormFields = {
  email: '',
};

interface PasswordResetIdentifier {
  email_address?: string;
}

interface PasswordResetFormProps {
  showLoginForm?: Function;
}

const PasswordResetForm: React.FC<PasswordResetFormProps> = ({ showLoginForm }) => {
  const [emailIsSent, setEmailIsSent] = useState<boolean>(false);

  const onLoginFormSwitch = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (showLoginForm) showLoginForm();
  };

  const handleSubmit: FormSubmitHandler<FormFields> = (data): void => {
    const identifiers: PasswordResetIdentifier = {};

    identifiers.email_address = data.email;

    const passwordResetCredentials = { identifiers };

    const apiBaseUrl = window.ZephrConfiguration?.apiBaseUrl || '';
    const apiEndpoint = window.ZephrConfiguration?.apiBaseUrl
      ? '/api/send-reset-password-email'
      : '/blaize/users/reset';

    fetch(`${apiBaseUrl}${apiEndpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(passwordResetCredentials),
    });

    setEmailIsSent(true);
  };

  return (
    <div className={styles.container}>
      <Typography variant="h3" className={styles.title}>
        Tilbakestill passord
      </Typography>
      {emailIsSent ? (
        <>
          <Typography variant="body1" className={styles.text}>
            Hvis du allerede er registrert, sender vi deg en e-post med instruksjoner for tilbakestilling av passordet
            til den oppgitte e-posten.
          </Typography>
          <Typography variant="body1" className={styles.text}>
            Hvis du ikke mottar en e-post, prøv igjen senere eller{' '}
            <Typography variant="body1" component="span" className={styles.registerLink}>
              <a href="mailto:abo@finansavisen.no">kontakt oss</a>
            </Typography>
          </Typography>
          <Typography variant="body1" className={styles.registerLink}>
            <a href="/zephr/login" onClick={onLoginFormSwitch} id="btn-back-to-login">
              Tilbake til innlogging
            </a>
          </Typography>
        </>
      ) : (
        <>
          <Typography variant="body1" className={styles.text}>
            Hvis du ikke mottar en e-post, prøv igjen senere eller{' '}
            <Typography variant="body1" component="span" className={styles.registerLink}>
              <a href="mailto:abo@finansavisen.no">kontakt oss</a>
            </Typography>
          </Typography>
          <Form defaultValues={defaultValues} onSubmit={handleSubmit}>
            {() => (
              <>
                <FormInput
                  name="email"
                  type="text"
                  label="E-post *"
                  validate={FormValidator.all(FormValidator.isNotEmpty, FormValidator.isValidEmail)}
                />
                <Button id="btn-submit-reset-password" type="submit" fullWidth>
                  Tilbakestill passord
                </Button>
              </>
            )}
          </Form>
          <Typography variant="body1" className={styles.registerLink} color="grey-900">
            <a href="/zephr/login" onClick={onLoginFormSwitch} id="btn-back-to-login">
              Tilbake til innlogging
            </a>
          </Typography>
        </>
      )}
    </div>
  );
};

export default PasswordResetForm;
